module.exports = __webpack_public_path__ + "img/first-central.37d7942a.png";